"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CommonBaseError_1 = require("../Common/CommonBaseError");
exports.SessionApplicationServiceErrorName = "SessionApplicationServiceError";
class SessionApplicationServiceError extends CommonBaseError_1.CommonBaseError {
}
exports.SessionApplicationServiceError = SessionApplicationServiceError;
//# sourceMappingURL=ISessionApplicationService.js.map